import React, { useEffect, useState } from 'react';
import { HeadlineLevel, HeadlineMarkup } from './HeadlineEnum';
import { is } from '../../services/index';
import clsx from 'clsx';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Headline component
 * @param children {ReactNode} Headline child
 * @param level {HeadlineLevel|number} Headline size : 1-3
 * @param inverted {Boolean} Headline white color
 * @param typo {TypographyAlign} Typos alignement
 * @param onClick {Function} onClick Event
 * @param skeleton {Boolean} Headline Skeleton
 * @param accessibilityLabel {string} Accessibility label
 * @param testId {string} Test Id for Test Integration
 * - --------------- WEB PROPERTIES ----------------------------------
 * @param markup {string} h1 | h2 | h3
 * @param className {string} Additionnal css classes
 * - --------------- NATIVE PROPERTIES ----------------------------------
 * @param style {object} Additional styles
 * @param accessibilityActivate {boolean}
 */
const Headline = ({ level = HeadlineLevel.LEVEL1, markup, children, className, skeleton, inverted, onClick, testId, accessibilityLabel, typo, ...others }) => {
    const { styled } = useTrilogyContext();
    const [isLoading, setIsLoading] = useState(skeleton || false);
    const classes = hashClass(styled, clsx({
        headline: true,
        [is(`level-${level}`)]: level,
    }, typo, isLoading ? is('loading') : is('loaded'), inverted && is('inverted'), className));
    useEffect(() => {
        setIsLoading(skeleton || false);
    }, [skeleton]);
    /**
     * If no markup return div with default level 1
     * key in Enum works only in TS or with number enum for JS
     * for string enum (as in this case) we need to use Object.values.includes for JS usage
     * string enum aren't reverse mapped so the first solution doesn't work
     */
    const isCorrectMarkup = (stringMarkup) => {
        if (stringMarkup in HeadlineMarkup || Object.values(HeadlineMarkup).includes(stringMarkup))
            return true;
    };
    const Tag = markup && isCorrectMarkup(markup) ? markup : 'div';
    return (React.createElement(Tag, { "data-testid": testId, "aria-label": accessibilityLabel, onClick: onClick && onClick, className: classes, ...others }, children));
};
export default Headline;
//# sourceMappingURL=Headline.js.map